import {Image, UnstyledButton} from "@mantine/core";
import React from "react";
import ReadMore from "@/app/(index)/read-more";
import {IArticleListForm, TFile} from "@/form/article";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import cx from "clsx";
import {IconPlus} from "@tabler/icons-react";
import {useMediaQuery} from "@mantine/hooks";


interface IProps {
    homeArticles: {[key: string]: IArticleListForm[]},
}

const HomeNewsCard: React.FC<IProps> = ({ homeArticles }) => {
    const { fontSize, lang } = useGlobalStateStore();
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');


    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }
    return (
        <div className={cx("max-w-[1250px] mx-auto pt-[25px]", mediaQueryLessSM ? "pb-[25px]" : "pb-[15px]")}>
            <div className={cx(mediaQueryLessSM ? "" : "mx-auto", "w-[90%]")} >
                {
                    lang == "tw" ? (
                        <div className={cx("flex gap-[20px]", mediaQueryLessSM ? "flex-row" : "flex-col")}>

                            <UnstyledButton component={"a"}
                                            className={cx(mediaQueryLessSM ? "w-1/2" : "w-full")}
                                            href={homeArticles["listC_NEWS"]?.at(0)?.category == "LINK" ?  homeArticles["listC_NEWS"]?.at(0)?.linkUrl!! : `/news/detail/${homeArticles["listC_NEWS"]?.at(0)?.artId}`}
                                            target={homeArticles["listC_NEWS"]?.at(0)?.category == "LINK" ? '_blank' : '_parent'}
                            >
                                <div className="flex gap-[15px]">
                                    <Image
                                        radius={10}
                                        h={ mediaQueryLessSM ? 96 : 50 }
                                        src={`${process.env.NEXT_PUBLIC_API_HOST}/image/crop/${homeArticles["listC_NEWS"]?.at(0)?.coverArhId?.arhId}`} />
                                    <div className="flex flex-col gap-[5px] text-white">
                                        <div className={cx(loadCurrentFontSize(12, 14, 16))}>{homeArticles["listC_NEWS"]?.at(0)?.publishDate}</div>
                                        <div className={cx(loadCurrentFontSize(15, 18, 22), "font-bold", mediaQueryLessSM ? "line-clamp-2" : "line-clamp-1")}>{homeArticles["listC_NEWS"]?.at(0)?.titleC}</div>
                                    </div>
                                </div>
                            </UnstyledButton>
                            <UnstyledButton component={"a"}
                                            className={cx(mediaQueryLessSM ? "w-1/2" : "w-full")}
                                            href={homeArticles["listC_NEWS"]?.at(1)?.category == "LINK" ?  homeArticles["listC_NEWS"]?.at(1)?.linkUrl!! : `/news/detail/${homeArticles["listC_NEWS"]?.at(1)?.artId}`}
                                            target={homeArticles["listC_NEWS"]?.at(1)?.category == "LINK" ? '_blank' : '_parent'}
                            >
                                <div className="flex gap-[15px]">
                                    <Image
                                        radius={10}
                                        h={ mediaQueryLessSM ? 96 : 50 }
                                        src={`${process.env.NEXT_PUBLIC_API_HOST}/image/crop/${homeArticles["listC_NEWS"]?.at(1)?.coverArhId?.arhId}`} />
                                    <div className="flex flex-col gap-[5px] text-white">
                                        <div className={cx(loadCurrentFontSize(12, 14, 16))}>{homeArticles["listC_NEWS"]?.at(1)?.publishDate}</div>
                                        <div className={cx(loadCurrentFontSize(15, 18, 22), "font-bold ", mediaQueryLessSM ? "line-clamp-2" : "line-clamp-1")}>{homeArticles["listC_NEWS"]?.at(1)?.titleC}</div>
                                    </div>
                                </div>
                            </UnstyledButton>
                        </div>
                    ) : (
                        <div className={cx("flex gap-[20px]", mediaQueryLessSM ? "flex-row" : "flex-col")}>
                            <UnstyledButton component={"a"}
                                            className={cx(mediaQueryLessSM ? "w-1/2" : "w-full")}
                                            href={homeArticles["listE_NEWS"]?.at(0)?.category == "LINK" ?  homeArticles["listE_NEWS"]?.at(0)?.linkUrlE!! : `/news/detail/${homeArticles["listE_NEWS"]?.at(0)?.artId}`}
                                            target={homeArticles["listE_NEWS"]?.at(0)?.category == "LINK" ? '_blank' : '_parent'}
                            >
                                <div className="flex gap-[15px]">
                                    <Image
                                        radius={10}
                                        h={ mediaQueryLessSM ? 96 : 50 }
                                        src={`${process.env.NEXT_PUBLIC_API_HOST}/image/crop/${homeArticles["listE_NEWS"]?.at(0)?.coverArhId?.arhId}`} />
                                    <div className="flex flex-col gap-[5px] text-white">
                                        <div className={cx(loadCurrentFontSize(12, 14, 16))}>{homeArticles["listE_NEWS"]?.at(0)?.publishDate}</div>
                                        <div className={cx(loadCurrentFontSize(15, 18, 22), "font-bold", mediaQueryLessSM ? "line-clamp-2" : "line-clamp-1")}>{homeArticles["listE_NEWS"]?.at(0)?.titleE}</div>
                                    </div>
                                </div>
                            </UnstyledButton>
                            <UnstyledButton component={"a"}
                                            className={cx(mediaQueryLessSM ? "w-1/2" : "w-full")}
                                            href={homeArticles["listE_NEWS"]?.at(1)?.category == "LINK" ?  homeArticles["listE_NEWS"]?.at(1)?.linkUrlE!! : `/news/detail/${homeArticles["listE_NEWS"]?.at(1)?.artId}`}
                                            target={homeArticles["listE_NEWS"]?.at(1)?.category == "LINK" ? '_blank' : '_parent'}
                            >
                                <div className="flex gap-[15px]">
                                    <Image
                                        radius={10}
                                        h={ mediaQueryLessSM ? 96 : 50 }
                                        src={`${process.env.NEXT_PUBLIC_API_HOST}/image/crop/${homeArticles["listE_NEWS"]?.at(1)?.coverArhId?.arhId}`} />
                                    <div className="flex flex-col gap-[5px] text-white">
                                        <div className={cx(loadCurrentFontSize(12, 14, 16))}>{homeArticles["listE_NEWS"]?.at(1)?.publishDate}</div>
                                        <div className={cx(loadCurrentFontSize(15, 18, 22), "font-bold", mediaQueryLessSM ? "line-clamp-2" : "line-clamp-1")}>{homeArticles["listE_NEWS"]?.at(1)?.titleE}</div>
                                    </div>
                                </div>
                            </UnstyledButton>
                        </div>
                    )
                }
            </div>

            <div className={cx(mediaQueryLessSM ? "" : "flex justify-end pt-3 pr-3")}>
                <UnstyledButton className={cx("", mediaQueryLessSM ? "absolute right-[3%] bottom-[10px]" : "pt-3")}
                                component="a" href={"news/list/A"}>
                    <div className="flex gap-1 items-center">
                        <div className="font-bold text-[#d1d1d1] hover:text-white text-[14px]">{lang == "tw" ? "更多新聞" : "more news"}</div>
                        <IconPlus color={"#1f8a83"} stroke={3} size={16}/>
                    </div>
                </UnstyledButton>
            </div>

        </div>
    );
}

export default HomeNewsCard;
